import TypographyComponent from './Typography.component';

export * from './Typography.component';
export default TypographyComponent;
